// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__2Sj2M","relative":"styles_relative__EbCCG","center":"styles_center__jxRZ5"};